<template>
  <div>
    <nuxt class="page-content notranslate" />
    <BaseNotifications />
    <portal-target name="preview-layout" />
  </div>
</template>

<script>
import BaseNotifications from '@/components/BaseNotifications/BaseNotifications.vue';

export default {
  components: {
    BaseNotifications,
  },
  head: {
    bodyAttrs: {
      class: 'print-body notranslate',
    },
  },
};
</script>
